









import {
  defineComponent,
  PropType,
  computed,
} from '@vue/composition-api';
import NavBarCoffee from '@/components/nav-bar-coffee/index.vue';
import { goBack } from '@/api/native/utils';
import { ubtSetupModuleExpose } from '@/shared/utils/ubt/ubt-setup';
import router from '@/router';
import type { NavBarConfig } from '@/views_v2/verify-credit/types';

export default defineComponent({
  name: 'NavBar',
  components: {
    NavBarCoffee,
  },
  props: {
    config: {
      type: Object as PropType<NavBarConfig>,
      required: true,
    },
  },
  setup() {
    const onBack = () => {
      ubtSetupModuleExpose('finance_commonNavbar_pageExit', {
        currentPage: router.currentRoute.path,
      });

      goBack();
    };

    return {
      onBack,
    };
  },
});
